import React, {useEffect, useState} from 'react';
import InputMask from 'react-input-mask';


export const InputMaskedRegistrationNumberV2 = ({
  title,
  required,
  minLength,
  defaultValue,
  value,
  disabled,
  id,
  placeholder,
                                                    onChangeText,
  type = 'text',
  mask = 0,
  setValue,
  ...otherProps
}) => {

        const [initialMask, setInitialMask] = useState(mask);

    useEffect(() => {
        if (initialMask !== mask) {
            onChangeText && onChangeText('');
            setInitialMask(mask);
        }
    }, [mask, initialMask, onChangeText])


  const _onChange = (e) => {
    onChangeText && onChangeText(e.target.value);
  }


    const clean = ()=>{
        onChangeText && onChangeText('');
    }

  return (
      <div>
        <span className="text-bold">
          {title}
        </span>
        <InputMask type={type} mask={mask}
                   value={value}
                   minLength={minLength}
                   required={required} defaultValue={defaultValue}
                   disabled={disabled}
                   className="form-control mt-1" id={id}
                   placeholder={placeholder}
                   onChange={_onChange}
        >

        </InputMask>
      </div>

  )
}
